import dayjs from "dayjs";
import { ptonnuriPlace, ptonnuriPlaceByFloor } from "@/dummy/places";

// 데모 모드 체크
export const IS_DEMO_MODE = import.meta.env.VITE_DEMO_MODE === "true";

// ============================================================
// 더미 공동체 / 다락방 / 순 데이터
// ============================================================
export const demoCommunities = [
  { cmtCd: "PTK_UNI", cmtNm: "대학청년부", cpsCd: "PTK" },
  { cmtCd: "PTK_HOPE", cmtNm: "소망공동체", cpsCd: "PTK" },
  { cmtCd: "PTK_FAITH", cmtNm: "믿음공동체", cpsCd: "PTK" },
  { cmtCd: "PTK_LOVE", cmtNm: "사랑공동체", cpsCd: "PTK" },
  { cmtCd: "PTK_JOY", cmtNm: "기쁨공동체", cpsCd: "PTK" },
  { cmtCd: "PTK_PEACE", cmtNm: "평강공동체", cpsCd: "PTK" },
];

export const demoGarrets = [
  { garCd: "PTK_UNI_01", garNm: "1번 다락방", cmtCd: "PTK_UNI", cpsCd: "PTK" },
  { garCd: "PTK_UNI_02", garNm: "2번 다락방", cmtCd: "PTK_UNI", cpsCd: "PTK" },
  { garCd: "PTK_UNI_03", garNm: "3번 다락방", cmtCd: "PTK_UNI", cpsCd: "PTK" },
  { garCd: "PTK_HOPE_01", garNm: "1번 다락방", cmtCd: "PTK_HOPE", cpsCd: "PTK" },
  { garCd: "PTK_HOPE_02", garNm: "2번 다락방", cmtCd: "PTK_HOPE", cpsCd: "PTK" },
  { garCd: "PTK_FAITH_01", garNm: "1번 다락방", cmtCd: "PTK_FAITH", cpsCd: "PTK" },
  { garCd: "PTK_FAITH_02", garNm: "2번 다락방", cmtCd: "PTK_FAITH", cpsCd: "PTK" },
  { garCd: "PTK_LOVE_01", garNm: "1번 다락방", cmtCd: "PTK_LOVE", cpsCd: "PTK" },
  { garCd: "PTK_LOVE_02", garNm: "2번 다락방", cmtCd: "PTK_LOVE", cpsCd: "PTK" },
  { garCd: "PTK_JOY_01", garNm: "1번 다락방", cmtCd: "PTK_JOY", cpsCd: "PTK" },
  { garCd: "PTK_PEACE_01", garNm: "1번 다락방", cmtCd: "PTK_PEACE", cpsCd: "PTK" },
  { garCd: "PTK_PEACE_02", garNm: "2번 다락방", cmtCd: "PTK_PEACE", cpsCd: "PTK" },
];

export const demoLeafs = [
  { leafCd: "PTK_UNI_01_01", leafNm: "마태 1순", garCd: "PTK_UNI_01", cmtCd: "PTK_UNI", cpsCd: "PTK" },
  { leafCd: "PTK_UNI_01_02", leafNm: "마태 2순", garCd: "PTK_UNI_01", cmtCd: "PTK_UNI", cpsCd: "PTK" },
  { leafCd: "PTK_UNI_02_01", leafNm: "마가 1순", garCd: "PTK_UNI_02", cmtCd: "PTK_UNI", cpsCd: "PTK" },
  { leafCd: "PTK_UNI_02_02", leafNm: "마가 2순", garCd: "PTK_UNI_02", cmtCd: "PTK_UNI", cpsCd: "PTK" },
  { leafCd: "PTK_UNI_03_01", leafNm: "누가 1순", garCd: "PTK_UNI_03", cmtCd: "PTK_UNI", cpsCd: "PTK" },
  { leafCd: "PTK_HOPE_01_01", leafNm: "요한 1순", garCd: "PTK_HOPE_01", cmtCd: "PTK_HOPE", cpsCd: "PTK" },
  { leafCd: "PTK_HOPE_01_02", leafNm: "요한 2순", garCd: "PTK_HOPE_01", cmtCd: "PTK_HOPE", cpsCd: "PTK" },
  { leafCd: "PTK_HOPE_02_01", leafNm: "베드로 1순", garCd: "PTK_HOPE_02", cmtCd: "PTK_HOPE", cpsCd: "PTK" },
  { leafCd: "PTK_FAITH_01_01", leafNm: "요셉 1순", garCd: "PTK_FAITH_01", cmtCd: "PTK_FAITH", cpsCd: "PTK" },
  { leafCd: "PTK_FAITH_01_02", leafNm: "요셉 2순", garCd: "PTK_FAITH_01", cmtCd: "PTK_FAITH", cpsCd: "PTK" },
  { leafCd: "PTK_FAITH_02_01", leafNm: "다니엘 1순", garCd: "PTK_FAITH_02", cmtCd: "PTK_FAITH", cpsCd: "PTK" },
  { leafCd: "PTK_LOVE_01_01", leafNm: "루디아 1순", garCd: "PTK_LOVE_01", cmtCd: "PTK_LOVE", cpsCd: "PTK" },
  { leafCd: "PTK_LOVE_01_02", leafNm: "루디아 2순", garCd: "PTK_LOVE_01", cmtCd: "PTK_LOVE", cpsCd: "PTK" },
  { leafCd: "PTK_LOVE_02_01", leafNm: "마리아 1순", garCd: "PTK_LOVE_02", cmtCd: "PTK_LOVE", cpsCd: "PTK" },
  { leafCd: "PTK_JOY_01_01", leafNm: "안나 1순", garCd: "PTK_JOY_01", cmtCd: "PTK_JOY", cpsCd: "PTK" },
  { leafCd: "PTK_JOY_01_02", leafNm: "안나 2순", garCd: "PTK_JOY_01", cmtCd: "PTK_JOY", cpsCd: "PTK" },
  { leafCd: "PTK_PEACE_01_01", leafNm: "다윗 1순", garCd: "PTK_PEACE_01", cmtCd: "PTK_PEACE", cpsCd: "PTK" },
  { leafCd: "PTK_PEACE_01_02", leafNm: "다윗 2순", garCd: "PTK_PEACE_01", cmtCd: "PTK_PEACE", cpsCd: "PTK" },
  { leafCd: "PTK_PEACE_02_01", leafNm: "솔로몬 1순", garCd: "PTK_PEACE_02", cmtCd: "PTK_PEACE", cpsCd: "PTK" },
];

// 더미 건물 데이터
export const demoBuildings = [
  { bldCd: "PTK_PTK", bldNm: "평택온누리교회", cpsCd: "PTK" },
];

// ============================================================
// 더미 유저 데이터
// ============================================================
const ROLE_NAMES: Record<string, string> = {
  ADMIN: "시스템 관리자",
  LEADER: "리더십멤버",
  MINISTRY: "목회 지원",
  USER: "일반 사용자",
};

const STATE_NAMES: Record<string, string> = {
  "00": "대기",
  "01": "정상",
  "07": "정지",
  "08": "탈퇴",
  "09": "삭제",
};

interface DemoUserSeed {
  userName: string;
  telNo: string;
  roleId: string;
  userStateCode: string;
  leafCd: string;
  daysAgo: number; // 가입일 기준
}

const demoUserSeeds: DemoUserSeed[] = [
  // 관리자 / 리더 (대학청년부)
  { userName: "김온누리", telNo: "010-1234-5678", roleId: "ADMIN", userStateCode: "01", leafCd: "PTK_UNI_01_01", daysAgo: 480 },
  { userName: "이지혜", telNo: "010-2233-1100", roleId: "LEADER", userStateCode: "01", leafCd: "PTK_UNI_01_01", daysAgo: 410 },
  { userName: "박지성", telNo: "010-2345-6789", roleId: "USER", userStateCode: "01", leafCd: "PTK_UNI_02_01", daysAgo: 365 },
  { userName: "최서연", telNo: "010-3456-1234", roleId: "USER", userStateCode: "01", leafCd: "PTK_UNI_01_02", daysAgo: 300 },
  { userName: "정민호", telNo: "010-4567-2345", roleId: "USER", userStateCode: "01", leafCd: "PTK_UNI_02_02", daysAgo: 290 },
  { userName: "한지원", telNo: "010-5678-3456", roleId: "MINISTRY", userStateCode: "01", leafCd: "PTK_UNI_03_01", daysAgo: 270 },

  // 소망공동체
  { userName: "강은서", telNo: "010-6789-4567", roleId: "LEADER", userStateCode: "01", leafCd: "PTK_HOPE_01_01", daysAgo: 250 },
  { userName: "윤지훈", telNo: "010-7890-5678", roleId: "USER", userStateCode: "01", leafCd: "PTK_HOPE_01_02", daysAgo: 220 },
  { userName: "장하늘", telNo: "010-8901-6789", roleId: "USER", userStateCode: "01", leafCd: "PTK_HOPE_02_01", daysAgo: 200 },
  { userName: "서민재", telNo: "010-9012-7890", roleId: "USER", userStateCode: "01", leafCd: "PTK_HOPE_01_01", daysAgo: 180 },

  // 믿음공동체
  { userName: "문예린", telNo: "010-1122-3344", roleId: "LEADER", userStateCode: "01", leafCd: "PTK_FAITH_01_01", daysAgo: 175 },
  { userName: "오준석", telNo: "010-2233-4455", roleId: "USER", userStateCode: "01", leafCd: "PTK_FAITH_01_02", daysAgo: 160 },
  { userName: "백수아", telNo: "010-3344-5566", roleId: "USER", userStateCode: "01", leafCd: "PTK_FAITH_02_01", daysAgo: 150 },

  // 사랑공동체
  { userName: "조윤아", telNo: "010-4455-6677", roleId: "LEADER", userStateCode: "01", leafCd: "PTK_LOVE_01_01", daysAgo: 140 },
  { userName: "임도현", telNo: "010-5566-7788", roleId: "USER", userStateCode: "01", leafCd: "PTK_LOVE_01_02", daysAgo: 130 },
  { userName: "신가영", telNo: "010-6677-8899", roleId: "USER", userStateCode: "01", leafCd: "PTK_LOVE_02_01", daysAgo: 120 },
  { userName: "권태민", telNo: "010-7788-9900", roleId: "USER", userStateCode: "01", leafCd: "PTK_LOVE_01_01", daysAgo: 100 },

  // 기쁨공동체
  { userName: "황소영", telNo: "010-8899-0011", roleId: "USER", userStateCode: "01", leafCd: "PTK_JOY_01_01", daysAgo: 90 },
  { userName: "송재현", telNo: "010-9900-1122", roleId: "USER", userStateCode: "01", leafCd: "PTK_JOY_01_02", daysAgo: 80 },

  // 평강공동체
  { userName: "양지호", telNo: "010-1010-2020", roleId: "LEADER", userStateCode: "01", leafCd: "PTK_PEACE_01_01", daysAgo: 70 },
  { userName: "노유진", telNo: "010-2020-3030", roleId: "USER", userStateCode: "01", leafCd: "PTK_PEACE_01_02", daysAgo: 60 },
  { userName: "유채원", telNo: "010-3030-4040", roleId: "USER", userStateCode: "01", leafCd: "PTK_PEACE_02_01", daysAgo: 45 },

  // 승인 대기 (00)
  { userName: "이영희", telNo: "010-3456-7890", roleId: "USER", userStateCode: "00", leafCd: "PTK_UNI_01_02", daysAgo: 14 },
  { userName: "박민수", telNo: "010-4567-8901", roleId: "USER", userStateCode: "00", leafCd: "PTK_HOPE_02_01", daysAgo: 9 },
  { userName: "최하림", telNo: "010-5678-9012", roleId: "USER", userStateCode: "00", leafCd: "PTK_FAITH_02_01", daysAgo: 5 },
  { userName: "김도윤", telNo: "010-6789-0123", roleId: "USER", userStateCode: "00", leafCd: "PTK_LOVE_02_01", daysAgo: 2 },

  // 삭제 처리된 유저 (09) - 관리자 화면 외에는 안 보임
  { userName: "탈퇴회원1", telNo: "010-0000-0001", roleId: "USER", userStateCode: "09", leafCd: "PTK_UNI_01_01", daysAgo: 600 },
  { userName: "탈퇴회원2", telNo: "010-0000-0002", roleId: "USER", userStateCode: "09", leafCd: "PTK_HOPE_01_01", daysAgo: 500 },
];

const buildDemoUser = (seed: DemoUserSeed, index: number) => {
  const leaf = demoLeafs.find(l => l.leafCd === seed.leafCd)!;
  const garret = demoGarrets.find(g => g.garCd === leaf.garCd)!;
  const cmt = demoCommunities.find(c => c.cmtCd === leaf.cmtCd)!;
  const createdDate = dayjs().subtract(seed.daysAgo, "day").format("YYYY-MM-DDTHH:mm:ss");
  return {
    userId: `demo-user-${String(index + 1).padStart(3, "0")}`,
    userName: seed.userName,
    telNo: seed.telNo,
    email: `${seed.userName}@demo.spoton`,
    cpsCd: "PTK",
    cmtCd: cmt.cmtCd,
    cmtNm: cmt.cmtNm,
    garCd: garret.garCd,
    garNm: garret.garNm,
    leafCd: leaf.leafCd,
    leafNm: leaf.leafNm,
    roleId: seed.roleId,
    roleName: ROLE_NAMES[seed.roleId] ?? seed.roleId,
    userStateCode: seed.userStateCode,
    userStateCodeName: STATE_NAMES[seed.userStateCode] ?? seed.userStateCode,
    createdDate,
    lastLoginDate: dayjs().subtract(Math.floor(Math.random() * 7), "day").format("YYYY-MM-DDTHH:mm:ss"),
    loginFailCount: 0,
    permissions: seed.roleId === "ADMIN" ? "parking" : "",
  };
};

// 더미 유저 데이터
export const demoUsers = demoUserSeeds.map(buildDemoUser);

// ============================================================
// 더미 예약 데이터
// ============================================================
const PURPOSES = [
  "순모임", "예배팀 연습", "새가족 모임", "다락방 모임", "찬양팀 연습",
  "성경공부", "리더 모임", "중보기도 모임", "교사 회의", "청년 수련회 준비",
  "QT 나눔", "전도 훈련", "북클럽", "사역 회의", "상담",
];
const STATUS_POOL = ["request", "approve", "approve", "approve", "approve", "reject", "cancel"];

// 결정론적 시드 (페이지 새로고침 시 같은 데이터)
let seedCounter = 1;
const seededRandom = () => {
  const x = Math.sin(seedCounter++) * 10000;
  return x - Math.floor(x);
};
const pick = <T,>(arr: T[]): T => arr[Math.floor(seededRandom() * arr.length)];
const pickInt = (min: number, max: number) => Math.floor(seededRandom() * (max - min + 1)) + min;

// 예약 가능한 (정상 상태 + 일반 사용 권한이 있는) 유저만
const reservableUsers = demoUsers.filter(u => u.userStateCode === "01");

const generateDemoReservations = () => {
  seedCounter = 1; // 매 실행마다 동일한 데이터를 만들기 위해 리셋
  const today = dayjs();
  const result = [];

  // 과거 30일 ~ 미래 30일 사이에 약 120건
  for (let i = 0; i < 120; i++) {
    const dayOffset = pickInt(-30, 30);
    const date = today.add(dayOffset, "day");
    const rsvtDt = date.format("YYYYMMDD");

    const place = ptonnuriPlace[Math.floor(seededRandom() * ptonnuriPlace.length)];
    const user = reservableUsers[Math.floor(seededRandom() * reservableUsers.length)];
    const status = pick(STATUS_POOL);

    const startHour = pickInt(8, 20);
    const duration = pickInt(1, 3);
    const endHour = Math.min(22, startHour + duration);

    result.push({
      rsvtId: i + 1,
      useCnts: pick(PURPOSES),
      plcCd: place.plcCd,
      plcNm: place.plcNm,
      rsvtDt,
      startTime: `${startHour.toString().padStart(2, "0")}0000`,
      endTime: `${endHour.toString().padStart(2, "0")}0000`,
      mbrId: user.userId,
      userId: user.userId,
      userName: user.userName,
      sttCd: status,
      telNo: user.telNo,
      cpsCd: "PTK",
      bldCd: "PTK_PTK",
      cmtCd: user.cmtCd,
      cmtNm: user.cmtNm,
      garCd: user.garCd,
      garNm: user.garNm,
      leafCd: user.leafCd,
      leafNm: user.leafNm,
    });
  }

  return result;
};

export const demoReservations = generateDemoReservations();

// 월별 예약 데이터 그룹화
export const getDemoMonthlyReservations = (yearMonth: string) => {
  const filtered = demoReservations.filter(r => r.rsvtDt.startsWith(yearMonth));

  const grouped: Record<string, typeof filtered> = {};
  filtered.forEach(r => {
    if (!grouped[r.rsvtDt]) {
      grouped[r.rsvtDt] = [];
    }
    grouped[r.rsvtDt].push(r);
  });

  return Object.entries(grouped).map(([day, data]) => ({ day, data }));
};

// 장소 데이터
export const getDemoPlaces = () => ptonnuriPlaceByFloor;
export const getDemoPlaceList = () => ptonnuriPlace;

// ============================================================
// 더미 주차 데이터 (데모 모드 전용)
// ============================================================
export const demoParkingRecords = [
  { name: "김온누리", phone: "010-1000-0001", community: "대학청년부 1순", team: "찬양사역팀", car: "현대 아반떼", plate: "12가 3456" },
  { name: "이평택", phone: "010-1000-0002", community: "베드로 2순", team: "유년부교사", car: "기아 K5", plate: "23나 4567" },
  { name: "박소망", phone: "010-1000-0003", community: "여호수아 3순", team: "새가족부", car: "제네시스 G70", plate: "34다 5678" },
  { name: "최은혜", phone: "010-1000-0004", community: "대학청년부 2순", team: "미디어팀", car: "쉐보레 트레일블레이저", plate: "45라 6789" },
  { name: "정진리", phone: "010-1000-0005", community: "바울 1순", team: "운영위원회", car: "BMW 3시리즈", plate: "56마 7890" },
  { name: "강평강", phone: "010-1000-0006", community: "마리아 1순", team: "중등부교사", car: "현대 팰리세이드", plate: "67바 8901" },
  { name: "윤사랑", phone: "010-1000-0007", community: "다니엘 2순", team: "고등부교사", car: "기아 카니발", plate: "78사 9012" },
  { name: "임기쁨", phone: "010-1000-0008", community: "여호수아 1순", team: "주일학교", car: "현대 투싼", plate: "89아 0123" },
  { name: "서충성", phone: "010-1000-0009", community: "베드로 1순", team: "장로회", car: "렉서스 ES300", plate: "90자 1234" },
  { name: "한자유", phone: "010-1000-0010", community: "바나바 3순", team: "여전도회", car: "기아 쏘렌토", plate: "12차 2345" },
  { name: "신축복", phone: "010-1000-0011", community: "디모데 1순", team: "청년부", car: "현대 아이오닉5", plate: "23카 3456" },
  { name: "오감사", phone: "010-1000-0012", community: "마태 2순", team: "성가대", car: "테슬라 Model 3", plate: "34타 4567" },
  { name: "권믿음", phone: "010-1000-0013", community: "요한 1순", team: "운영위원회", car: "볼보 XC60", plate: "45파 5678" },
  { name: "황소망", phone: "010-1000-0014", community: "스데반 2순", team: "찬양사역팀", car: "쉐보레 스파크", plate: "56하 6789" },
  { name: "안지혜", phone: "010-1000-0015", community: "누가 1순", team: "새가족부", car: "기아 모닝", plate: "67거 7890" },
  { name: "송평안", phone: "010-1000-0016", community: "바나바 1순", team: "미디어팀", car: "현대 쏘나타", plate: "78너 8901" },
  { name: "류기도", phone: "010-1000-0017", community: "디모데 2순", team: "장년부", car: "기아 스포티지", plate: "89더 9012" },
  { name: "전희락", phone: "010-1000-0018", community: "마가 1순", team: "주일학교", car: "벤츠 E클래스", plate: "90러 0123" },
  { name: "고성실", phone: "010-1000-0019", community: "여호수아 4순", team: "청년부", car: "현대 그랜저", plate: "12머 1234" },
  { name: "백온유", phone: "010-1000-0020", community: "베드로 3순", team: "중등부교사", car: "기아 EV6", plate: "23버 2345" },
  { name: "유양선", phone: "010-1000-0021", community: "바울 2순", team: "고등부교사", car: "르노 XM3", plate: "34서 3456" },
  { name: "남헌신", phone: "010-1000-0022", community: "마리아 2순", team: "여전도회", car: "현대 코나", plate: "45어 4567" },
  { name: "홍동역", phone: "010-1000-0023", community: "스데반 1순", team: "장로회", car: "기아 레이", plate: "56저 5678" },
  { name: "문섬김", phone: "010-1000-0024", community: "누가 2순", team: "성가대", car: "벤츠 GLC", plate: "67처 6789" },
  { name: "양섬광", phone: "010-1000-0025", community: "디모데 3순", team: "운영위원회", car: "BMW X3", plate: "78커 7890" },
  { name: "손화평", phone: "010-1000-0026", community: "요한 2순", team: "찬양사역팀", car: "현대 스타리아", plate: "89터 8901" },
  { name: "배예향", phone: "010-1000-0027", community: "마태 1순", team: "새가족부", car: "기아 니로", plate: "90퍼 9012" },
  { name: "조생명", phone: "010-1000-0028", community: "바나바 2순", team: "주일학교", car: "아우디 A4", plate: "12허 0123" },
  { name: "허광명", phone: "010-1000-0029", community: "여호수아 2순", team: "청년부", car: "현대 캐스퍼", plate: "23그 1234" },
  { name: "남궁영광", phone: "010-1000-0030", community: "베드로 4순", team: "장년부", car: "기아 쏘울", plate: "34느 2345" },
];
